import React from 'react'

export default ({widget: {title, sponsors}}) => {

  return(
    <div style={{display: "flex", flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      marginTop: 30,
    }}>
      <h3 className="uk-heading-line uk-text-center uk-text-uppercase text-saddle uk-width-1-1 uk-margin-small-bottom">
        <span style={{ color: "#8A7A67", fontFamily: "ProximaNovaBold, Arial, \"Lucida Grande\", sans-serif",
          fontSize: 18, fontWeight: 800, textAlign: "center" }}>
          {title}
        </span>
      </h3>
      <div className="uk-grid uk-width-large">
        {
          sponsors && sponsors.length > 1 && sponsors.map((s) => (
            <a href={s.link} className="uk-width-1-2 uk-flex"
               style={{justifyContent: "center", minHeight: 50, marginBottom: 20}} target="_blank">
              <div style={{maxWidth: 130, alignItems: "center"}} className="uk-flex">
                <img style={{maxHeight: "100%"}} src={s.image.url} alt="todo-fill-this" />
              </div>
            </a>
          ))
        }
        {
          sponsors && sponsors.length === 1 &&
            <a href={sponsors[0].link} className="uk-width-1-1 uk-flex"
               style={{justifyContent: "center", minHeight: 50, maxHeight: 100, marginBottom: 20}} target="_blank">
              <div style={{maxWidth: 130, alignItems: "center"}} className="uk-flex">
                <img style={{maxHeight: "100%"}}  src={sponsors[0].image.url} alt="todo-fill-this" />
              </div>
            </a>
        }
      </div>
    </div>
  )
}